const angular = require('angular')
const filter = require('lodash/filter')
const forEach = require('lodash/forEach')
const findIndex = require('lodash/findIndex')
const sortBy = require('lodash/sortBy')
const every = require('lodash/every')
const cloneDeep = require('lodash/cloneDeep')
const { hook: globalHook } = require('js/global/module')

module.exports = ['$scope', '$rootScope', '$stateParams', '$translate', '$utils', 'mailFolderService', '$phoneModal', 'Message', '$q',
  '$state', 'KeywordSearchMail', '$timeout', '$sce', '$ionicActionSheet', '$ionicHistory', '$window',
  '$ionicScrollDelegate', '$ionicListDelegate', 'secondAuthService', 'MailFolderType', 'contactService', 'User', 'globalFolderService', 'IndexedDB', 'sharedMailboxService', '$cookies',
  function ($scope, $rootScope, $stateParams, $translate, $utils, mailFolderService, $phoneModal, Message, $q,
    $state, KeywordSearchMail, $timeout, $sce, $ionicActionSheet, $ionicHistory, $window,
    $ionicScrollDelegate, $ionicListDelegate, secondAuthService, MailFolderType, contactService, User, globalFolderService, IndexedDB, sharedMailboxService, $cookies) {
    const fid = parseInt($stateParams.fid || 0)
    $scope.fid = fid
    const isMailDealings = $state.current.name === 'frame.maildealings'
    $scope.messagesBelowTag = []
    $scope.searchModalOpen = false
    $scope.isSelectMode = false
    $scope.msgHandlerDelegate = {}
    $scope.hideAvatar = $rootScope.settings['show-list-avatar'] === false ? 'hide-avatar' : ''
    $scope.per = 20
    $scope.isAppEmbed = $utils.$misc.MD.isAppEmbed
    $scope.isLoading = true // 初始化填充loading
    $rootScope.$on('refresh-draft', function() {
      initMailFolder()
    })
    // 初始化共享邮箱
    $scope.showMailboxAccounts = false // 是否显示邮箱账号列表页
    $scope.showSearchAccounts = false // 是否显示搜索账号下拉框
    $scope.searchAccounts = [] // 可搜索的邮箱账号（含共享邮箱）
    $scope.currentSearchAccount = ''
    if ($rootScope.settings.settingMenu.sharedMailbox) {
      const userConfig = User.getConfig()
      $scope.mainMailbox = { email: userConfig.email, _access: -1 }
      $scope.selectedMailbox = $scope.mainMailbox
      getMailboxUnreadMsgCount([$scope.selectedMailbox])
      getVisibleSharedMailbox()
    }
    initMailFolder()

    // 显示或隐藏账号列表页
    $scope.toggleMailboxAccounts = function (visible) {
      $scope.showMailboxAccounts = !visible
      if ($scope.showMailboxAccounts) {
        const tempList = $scope.visibleMailboxList.concat([$scope.mainMailbox])
        getMailboxUnreadMsgCount(tempList)
      }
    }

    // 选择邮箱账号
    $scope.selectMailbox = function (mailbox) {
      const tempList = [$scope.mainMailbox].concat($scope.visibleMailboxList)
      User.updateMailboxAccounts({selectedAccount: tempList.find(item => item.email === mailbox.email)})
      const mailboxAccounts = User.getMailboxAccounts()
      if ($scope.selectedMailbox.email === mailboxAccounts.selectedAccount.email) {
        $scope.showMailboxAccounts = false
      } else {
        $scope.selectedMailbox = mailboxAccounts.selectedAccount
        $scope.currentSearchAccount = $scope.selectedMailbox.email
        // 当前邮箱账号权限
        $scope.currentAccountAccess = User.getSelectedAccountAccess()
        $scope.activeAccountAccess = User.getSelectedAccountAccess()
        $ionicHistory.clearCache().then(function () {
          $scope.switchingAccount = true // 是否在切换账号
          mailFolderService.clearFolders()
          initMailFolder()
          $scope.showMailboxAccounts = false
          $scope.showFolders = false
        })
      }
    }
    // 获取主账号或共享账号的邮件未读数
    function getMailboxUnreadMsgCount(accounts) {
      accounts.forEach(item => {
        const mboxa = item.id ? `@${item.id}` : ''
        globalFolderService.getFolderStatsInfo(-2, mboxa).then(
          function (data) {
            item['unreadMessageCount'] = data.unreadMessageCount
          }
        )
      })
    }
    // 获取需要显示的共享邮箱
    function getVisibleSharedMailbox() {
      const mailboxAccounts = User.getMailboxAccounts()
      $scope.visibleMailboxList = mailboxAccounts.visibleMailboxList
      // 当前邮箱账号权限
      $scope.currentAccountAccess = User.getSelectedAccountAccess()
      $scope.activeAccountAccess = User.getSelectedAccountAccess()
      $scope.showSearchAccounts = true
      $scope.currentSearchAccount = $scope.mainMailbox.email
    }
    // 账号共享权限转换
    $scope.transformSharedAccess = function (access) {
      switch (access) {
        case 0:
          return $translate.instant('SETTING.SHARED_MAILBOX.READ_ONLY')
        case 1:
          return $translate.instant('SETTING.SHARED_MAILBOX.AGENT')
        case 2:
          return $translate.instant('SETTING.SHARED_MAILBOX.DELEGATE')
      }
    }
    // 重置选中的邮箱账号
    function resetSelectedMailbox() {
      if ($rootScope.settings.settingMenu.sharedMailbox) {
        const mailboxAccounts = User.getMailboxAccounts()
        $scope.selectedMailbox = mailboxAccounts.selectedAccount || mailboxAccounts.mainAccount
      }
    }
    /** 初始化时获取所有的文件夹 */
    function initMailFolder() {
      mailFolderService.listFolders().then(function (folders) {
        resetSelectedMailbox()
        getCurrentFolderStats()
        addUnreadRefreshListener()
        $scope.selectFolder(fid, folders)
      })
    }
    // 初始化当前文件夹
    $scope.selectFolder = function (fid, folders) {
      if (fid != 0) {
        $scope.messageWrappers = null
        mailFolderService.getFolder(fid).then(function (folder) {
          if ($scope.switchingAccount && !folder) {
            $state.go('frame.folder', { fid: 1 }, { reload: true })
            return
          }
          wrapCurrentFolder(folder)
          $scope.folder = folder
          $scope.folder.fids = folders.realFolderIds

          $scope.noMoreMessage = false
          $utils.$uiHelper.scrollToTop('mailListContent')
          $scope.listMessages()
        }, function (reason) {
          console.debug('Cannot open folder[id=' + fid + '], ' + JSON.stringify(reason))
        }).finally(function () {
          $scope.switchingAccount && ($scope.switchingAccount = false)
        })
      }
    }
    // 获取当前文件夹的统计信息
    function getCurrentFolderStats() {
      globalFolderService.getFolderStatsInfo($scope.fid).then(function (data) {
        $scope.currentFolderStats = data
      }, function () {
        $scope.currentFolderStats = {}
      })
    }
    // 未读状态刷新
    function addUnreadRefreshListener() {
      $rootScope.$off('FOLDER.UNREADREFRESH')
      $rootScope.$on('FOLDER.UNREADREFRESH', function () {
        getCurrentFolderStats()
      })
    }
    // 计算当前文件夹的子文件夹未读数
    function wrapCurrentFolder(folder) {
      folder.subFoldersUnread = 0
      if (folder.children) {
        folder.children.forEach(function (item) {
          folder.subFoldersUnread = folder.subFoldersUnread + wrapCurrentFolder(item)
        })
        return folder.subFoldersUnread + folder.stats.unreadMessageCount
      } else {
        return folder.stats.unreadMessageCount
      }
    }
    // wrapFolers和recursiveUnreadCount一起用于计算每个文件夹的子文件夹未读数和，用于控制文件夹的未读提示点显示
    function wrapFolders(folders) {
      folders.forEach(function (folder) {
        recursiveUnreadCount(folder)
      })
    }
    function recursiveUnreadCount(folder) {
      folder.data.subFoldersUnread = 0
      if (folder.children) {
        folder.children.forEach(function (item) {
          folder.data.subFoldersUnread = folder.data.subFoldersUnread + recursiveUnreadCount(item)
        })
        return folder.data.subFoldersUnread + folder.data.stats.unreadMessageCount
      } else {
        return folder.data.stats.unreadMessageCount
      }
    }
    let clearWatch
    $scope.inSearchPage = function () {
      LA.track('A1B2')
      $scope.searchModalOpen = true
      $scope.searchNoResult = false
      $scope.searchData = {
        selectedTag: '',
        keyword: ''
      }
      setTimeout(function () {
        $scope.isSelectMode = false
        $ionicListDelegate.closeOptionButtons()
        $scope.tempModal = $phoneModal.fromTemplate(require('views/mail/search-page.html'), {
          scope: $scope,
          animation: 'scale-in'
        })
        $scope.noSearchMail = true
        // $utils.$modalFunc.prepareModalBack($scope.tempModal)
        $scope.tempModal.show()
        const currentStateId = $ionicHistory.currentView().stateId
        clearWatch = $scope.$watch(function () {
          return $ionicHistory.currentView().stateId
        }, function (newValue) {
          if (newValue === currentStateId && $scope.tempModal) {
            $scope.tempModal.show()
          } else if (!$scope.tempModal) {
            clearWatch()
          }
        })
      }, 0)
    }

    //  搜索列表加载更多
    $scope.loadMoreSearchMessages = function (keyword) {
      const keywordSearchMail = $scope.keywordSearchMail || new KeywordSearchMail(keyword)
      if ($scope.messages.length < keywordSearchMail.totals) {
        keywordSearchMail.loadMoreMessages($scope.messages.length, keywordSearchMail.mboxa).then(function (data) {
          updateSearchMessages(data)
        })
      }
    }

    //  往来邮件列表加载更多
    $scope.loadMoreMailDealings = function () {
      const keywordSearchMail = $scope.keywordSearchMail || new KeywordSearchMail('', $state.params.contactId)
      if ($scope.messages.length < keywordSearchMail.totals) {
        keywordSearchMail.fetchMailDealings($scope.messages.length).then(function (data) {
          updateMailDealings(data)
        })
      }
    }

    $scope.hideMenu = function () {
      $ionicListDelegate.closeOptionButtons()
    }

    $scope.hideSearchModal = function () {
      $scope.tempModal.hide()
    }

    $scope.closeSearchModal = function () {
      $scope.searchModalOpen = false
      $scope.msgHandlerDelegate.readForbidden = false
      $scope.messagesBelowTag = null
      $scope.messages = null
      $scope.searchNoResult = true
      clearWatch()
      $scope.tempModal.remove()
      $scope.activeAccountAccess = User.getSelectedAccountAccess()
    }

    function getCurrentSearchMboxa() {
      const mailboxAccounts = User.getMailboxAccounts()
      const visibleAccounts = mailboxAccounts.visibleMailboxList ? mailboxAccounts.visibleMailboxList : []
      const tempAccount = visibleAccounts.find(i => { return i.email === $scope.currentSearchAccount })
      const mboxId = tempAccount ? (tempAccount.id === 0 ? 0 : tempAccount.id || '') : ''
      return mboxId ? `@${mboxId}` : ''
    }
    // 搜索邮件
    $scope.searchContent = function (selectedTag, keyword) {
      document.querySelector('#searchInput').blur()
      $scope.searching = true
      $scope.noMoreEmailMessage = false
      $scope.messages = []
      const mboxa = getCurrentSearchMboxa()
      if (keyword != '') {
        const keywordSearchMail = mailFolderService.getSearchFolder({
          searchField: selectedTag,
          keyword,
          refresh: false,
          mboxa
        })
        $scope.keywordSearchMail = keywordSearchMail
        keywordSearchMail.getMid(mboxa).then(function (data) {
          keywordSearchMail.fetchMessages(0, mboxa).then(function (data) {
            updateSearchMessages(data)
          }, function (reason) {
            $scope.searchNoResult = false
            $scope.changeKeyword = keyword
            $scope.searching = false
          })
        }, function () {
          $scope.searchNoResult = false
          $scope.changeKeyword = keyword
          $scope.searching = false
        })
      }
    }

    // 切换搜索结果显示
    $scope.handleTagSwitch = function (tag) {
      switch (tag) {
        case '':
          LA.track('A1B201')
          break
        case 'from':
          LA.track('A1B202')
          break
        case 'to':
          LA.track('A1B203')
          break
        case 'subject':
          LA.track('A1B204')
          break
      }
      $scope.searchData.selectedTag = tag
      if (!$scope.searchData.keyword) {
        return
      }
      $scope.searchContent($scope.searchData.selectedTag, $scope.searchData.keyword, false)
    }
    function getMailDealings(refresh) {
      $scope.noMoreEmailMessage = false

      let email = $stateParams.contactId
      if (!$rootScope.pabMailDealing) {
        contactService.getOabContact($stateParams.contactId).then(function (contact) {
          contact.email && (email = contact.email)
        }, function (error) {
          console.log(error)
        }).finally(function () {
          const KeywordSearchMail = mailFolderService.getSearchFolder({
            searchField: email,
            keyword: true,
            refresh: true
          })
          $scope.keywordSearchMail = KeywordSearchMail
          if (refresh) KeywordSearchMail.start = 0
          $scope.messages = []
          $scope.title = {
            name: $stateParams.name || email.split('@')[0]
          }
          KeywordSearchMail.fetchMailDealings().then(function (data) {
            updateMailDealings(data)
          }, function (data) {
            $utils.$notify.set({ message: $translate.instant('TIPS.' + data.code) })
          }).finally(function () {
            $scope.$broadcast('scroll.refreshComplete')
            $scope.isLoading = false
          })
        })
      } else {
        const KeywordSearchMail = mailFolderService.getSearchFolder({
          searchField: email,
          keyword: true,
          refresh: true
        })
        $scope.keywordSearchMail = KeywordSearchMail
        if (refresh) KeywordSearchMail.start = 0
        $scope.messages = []
        $scope.title = {
          name: $stateParams.name || email.split('@')[0]
        }
        KeywordSearchMail.fetchMailDealings().then(function (data) {
          updateMailDealings(data)
        }, function (data) {
          $utils.$notify.set({ message: $translate.instant('TIPS.' + data.code) })
        }).finally(function () {
          $scope.$broadcast('scroll.refreshComplete')
          $scope.isLoading = false
        })
      }
    }

    $scope.backToDetail = function () {
      $state.go('frame.detail', {
        contactId: $state.params.contactId,
        name: $state.params.name
      })
      if ($rootScope.pabMailDealing) {
        $rootScope.pabMailDealing = false
        window.history.go(-1)
      }
    }

    //  更新搜索列表邮件信息
    function updateSearchMessages(data) {
      const keywordSearchMail = $scope.keywordSearchMail
      const keyword = keywordSearchMail.keyword
      let messageInfo

      if (data.length === 0) {
        $scope.searchNoResult = true
        $scope.changeKeyword = keyword
        $scope.searching = false
      }
      for (let i = 0; i < data.length; i++) {
        $scope.searchNoResult = false
        $scope.searching = false

        messageInfo = data[i].messageInfo
        messageInfo.name = $utils.$email.parseTrueName(messageInfo.from)
        messageInfo.email = $utils.$email.parse(messageInfo.from).addr
        messageInfo.isStranger = contactService.isStranger(messageInfo.from)

        let temp = {}
        temp = data[i]
        temp.messageInfo.highLightSubject = _handleHighLight(keyword, messageInfo.subject)
        temp.messageInfo.hightLightSummary = _handleHighLight(keyword, messageInfo.summary)
        temp.messageInfo.hightLightName = _handleHighLight(keyword, messageInfo.name)
        temp.messageInfo.hightLightEmail = _handleHighLight(keyword, messageInfo.email)
        $scope.messages.push(temp)
      }
      $scope.messagesBelowTag = $scope.messages
      // 设置搜索邮件集合的账号权限类型
      const mboxa = keywordSearchMail.mboxa
      const mboxId = mboxa ? parseInt(mboxa.split('@')[1]) : undefined
      // 当前搜索邮箱账号权限
      $scope.activeAccountAccess = mboxa === '' ? -1 : (mboxId ? User.getAccountAccessById(mboxId) : User.getSelectedAccountAccess())
      if (keywordSearchMail.start >= keywordSearchMail.totals) { // 没有更多邮件
        $scope.noSearchMail = false
        $scope.noMoreEmailMessage = true
      } else {
        $scope.noSearchMail = false
      }
      $ionicScrollDelegate.resize()
    }

    function updateMailDealings(data) {
      const KeywordSearchMail = $scope.keywordSearchMail
      $scope.noMail = data.length === 0
      for (let i = 0; i < data.length; i++) {
        data[i].messageInfo.name = $utils.$email.parseTrueName(data[i].messageInfo.from)
        data[i].messageInfo.email = $utils.$email.parse(data[i].messageInfo.from).addr
        $scope.messages.push(data[i])
      }
      if (KeywordSearchMail.start >= KeywordSearchMail.totals) { // 没有更多邮件
        $scope.noMoreEmailMessage = true
      }
      $ionicScrollDelegate.resize()
    }

    $scope.keepTipsRight = function () {
      $scope.searchNoResult = true
    }

    function _handleHighLight(keyword, message) {
      // message = $utils.$html.encode(message)
      if (message) {
        const pattern = new RegExp(keyword, 'im')
        const tempName = message.replace(pattern, "<span class='highlight' style='vertical-align:top'>$&</span>")
        return $sce.trustAsHtml(tempName)
      }
    }
    $scope.msgHandlerDelegate.removeMessages = function (aMessageWrappers, mboxa) {
      let messageToRemove = []
      let fid
      if ($scope.tempModal || isMailDealings) {
        /** 正在搜索列表 */
        /** it is searching */
        fid = aMessageWrappers[0].messageInfo.fid
      } else {
        fid = $scope.folder.id
      }

      $ionicActionSheet.show({
        titleText: $translate.instant(fid == 4 ? 'MAIL_OP_TIPS.ALERT_REAL_DELETE' : 'MAIL_OP_TIPS.ALERT_MAIL_DELETE'),
        destructiveText: "<p class='actionText'>" + $translate.instant('OP.DELETE') + '</p>',
        cancelText: $translate.instant('OP.CANCEL'),
        destructiveButtonClicked: function () {
          if ($scope.isSelectMode) {
            $scope.toggleSelectMode()
          }

          mailFolderService.getFolder(fid, mboxa).then(function (oFolder) {
            const messages = oFolder.messages
            for (let i = 0; i < aMessageWrappers.length; ++i) {
              for (let j = 0; j < messages.length; ++j) {
                if (aMessageWrappers[i].messageInfo.id == messages[j].messageInfo.id) {
                  messageToRemove.push(aMessageWrappers[i])
                  break
                }
              }
            }
            if (messageToRemove.length == 0) {
              messageToRemove = aMessageWrappers
            }
            oFolder.removeMessages(messageToRemove, mboxa).then(function () {
              let tips = fid == 4 ? 'MAIL_OP_TIPS.SUCCESS_REAL_DELETE' : 'MAIL_OP_TIPS.SUCCESS_DELETE'
              tips = $translate.instant(tips, { number: messageToRemove.length })
              $utils.$notify.set({ message: tips })

              // 非当前邮箱账号删除邮件不更新列表状态
              const currentMboxa = User.getSelectedAccountSymbol()
              if (currentMboxa !== mboxa) return
              /** 更新列表状态 */
              /** update list state */
              $rootScope.$emit(isMailDealings ? 'MAILLIST.REFRESH' : 'LIST.REFRESH')
            })
          })
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    // 读信操作
    $scope.msgHandlerDelegate.readMessage = function (messageItem, mboxa) {
      let messageId = ''
      let searchModal, keyword
      if (!$scope.isSelectMode && !$scope.msgHandlerDelegate.readForbidden) {
        if (isMailDealings) {
          searchModal = true
          keyword = $scope.keywordSearchMail.dealings
        } else if ($scope.tempModal && $scope.tempModal._isShown == true) {
          if ($scope.keywordSearchMail.keyword) {
            searchModal = true
            keyword = $scope.keywordSearchMail.keyword
          }
          $scope.tempModal.hide()
          // $scope.messages = null;
        }
        messageId = messageItem.messageInfo.id
        // 设置共享账号标识mboxa
        const _mboxa = mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
        if (messageItem.messageInfo.fid !== 2) {
          if (searchModal) {
            // 随机数为了解决数据同步问题, 所以不添加缓存
            $state.go('frame.readDealing', {
              mid: messageId,
              isMailDealings: isMailDealings,
              name: $stateParams.name,
              fid: isMailDealings ? messageItem.messageInfo.fid : $scope.folder.id,
              keyword: keyword,
              selectedTag: $scope.searchData.selectedTag,
              random: Math.random(),
              mboxa: _mboxa
            })
          } else {
            $state.go('frame.read', { mid: messageId, fid: $scope.folder.id, mboxa: _mboxa }, { reload: !!messageItem.isFlagChanged })
          }
        } else {
          $state.go('frame.compose', { action: 'restore', mid: messageId, mboxa: _mboxa })
        }
      }
    }

    // 单个邮件移动
    $scope.msgHandlerDelegate.moveMessage = function (oMessageItem, mboxa) {
      moveMsgsToFolder([oMessageItem], mboxa)
    }

    // 选择模式移动邮件
    $scope.moveSelected = function () {
      LA.track('A1D103')
      const aMessages = getSelectedMailId()
      if (aMessages && aMessages.length > 0) {
        moveMsgsToFolder(aMessages)
      }
    }

    function moveMsgsToFolder(aMessages, mboxa) {
      $scope.folderHandlerDelegate = {
        selectFolder: function (iFolderId) {
          $scope.closeSelectFolderModal()
          if (aMessages) {
            $scope.isLoading = true
            mailFolderService.getFolder(iFolderId, mboxa).then(function (oFolder) {
              $scope.folder.moveMsgsToFolder(aMessages, oFolder, mboxa).then(function (data) {
                let sMessage = $translate.instant('MAIL_OP_TIPS.SUCCESS_MOVE')
                sMessage = sMessage.replace('{0}', aMessages.length).replace('{0}', oFolder.name)
                $utils.$notify.set({ message: sMessage })
                // 非当前邮箱账号移动邮件不更新列表状态
                const currentMboxa = User.getSelectedAccountSymbol()
                if (currentMboxa !== mboxa) return
                /** 更新列表状态 */
                /** update list state */
                $rootScope.$emit(isMailDealings ? 'MAILLIST.REFRESH' : 'LIST.REFRESH')
                // $scope.$emit('FOLDERS.REFRESH')
              })
            }, function (reason) {
              $utils.$notify.set({ message: $translate.instant('MAIL_OP_TIPS.MOVE_FAILED') })
              throw reason // todo
            }).finally(function () {
              $scope.isLoading = false
            })
          }
        }
      }
      openSelectFolderModal('move', aMessages, mboxa)
    }

    function removeMsgByIds(idArr) {
      let count = 0
      idArr.forEach(function (ele, index) {
        count++
        $scope.messageWrappers.splice(index - count, 1)
      })
    }

    function resetMsgList(messageWrappers) {
      $ionicHistory.clearCache()
      $scope.messageWrappers = messageWrappers
      $scope.folder.messages = $scope.messageWrappers
    }

    function handleFetchedMessages(messages) {
      /** mark index */
      forEach(messages, function (message, index) {
        message.index = index
      })

      /** handle new message */
      const different = filter(messages, function (obj) {
        const index = findIndex($scope.messageWrappers, function (sobj) {
          return sobj.id === obj.messageInfo.id
        })

        /** update message when it is existed */
        if (index > -1) {
          $scope.messageWrappers[index] = obj
        }

        return index === -1
      })

      $scope.messageWrappers = sortBy(different.concat($scope.messageWrappers), function (item) {
        return item.index
      })

      /** handle removed message */
      $scope.messageWrappers = $scope.messageWrappers.filter(function (obj) {
        return findIndex(messages, obj) > -1
      })

      /** reserved states */
      /** todo: 信息的处理应该交由 StorageMailFolder 存储和处理，因为读信页面的上下分页需要到 messages 数据 */
      $scope.folder.messages = $scope.messageWrappers
    }

    // 用于判断是否收到新邮件,用邮件的id作为界限;
    function handleFetchNewMessages(messageWrappers) { //eslint-disable-line
      if ($scope.messageWrappers.length == 0) {
        $scope.messageWrappers = messageWrappers
        $scope.mailTotal = messageWrappers.total
        $scope.folder.messages = $scope.messageWrappers
        watchMsgChange()
        console.log($scope.folder)
        return
      }
      console.log(messageWrappers.total, $scope.mailTotal)

      if (messageWrappers.length) {
        const messageIdArr = []
        messageWrappers.forEach(function (elem, index) {
          messageIdArr[index] = elem.messageInfo.id
        })
        const newestMessageId = $scope.messageWrappers[0].messageInfo.id
        const index = messageIdArr.indexOf(newestMessageId)

        if (index >= 0) {
          // Drafts shouldn't show newMessages;
          if ($scope.folder.id !== 2 && index !== 0) {
            $scope.hasNewMessage = true
            $scope.numOfNewMesage = index
            $timeout(function () {
              $scope.hasNewMessage = false
              $scope.numOfNewMesage = 0
            }, 3000)
          }
          // 更新列表中的信息
          const idOfLastNewMsg = messageIdArr[messageIdArr.length - 1]
          const idsToRemove = []
          let hasLastOne = false
          for (let i = 0; i < $scope.messageWrappers.length; i++) {
            const tempIndex = messageIdArr.indexOf($scope.messageWrappers[i].messageInfo.id)
            if (tempIndex != -1) {
              angular.extend($scope.messageWrappers[i], messageWrappers[tempIndex])
            } else {
              idsToRemove.push(i)
            }
            // 最后一封存在旧列表中,移除不存在的
            if ($scope.messageWrappers[i].messageInfo.id == idOfLastNewMsg) {
              console.log(idsToRemove)
              removeMsgByIds(idsToRemove)
              hasLastOne = true
              break
            }
          }
          // 最后一封都不在新列表中, 情况过于复杂, 重置列表页;
          if (!hasLastOne) {
            resetMsgList(messageWrappers)
            return
          }

          // 把新邮件放入列表
          for (let i = index; i > 0; i--) {
            $scope.messageWrappers.unshift(messageWrappers[i - 1])
            console.log($scope.messageWrappers[i])
          }
          $scope.folder.messages = $scope.messageWrappers
          $scope.mailTotal = messageWrappers.total
        } else if (index == -1) {
          // 两种情况, 一种新邮件超过20, 一种别的端删除的邮件数超过20
          if (messageWrappers.total > $scope.mailTotal + 20) {
            $scope.listMessages(0, messageWrappers.total - $scope.mailTotal + 20)
          } else {
            resetMsgList(messageWrappers)
          }
        }
        console.log($scope.folder)
      }
    }

    // isAddToTail用来区分是否是向列表尾部添加新邮件
    const updateMessageWrappers = function (aMessages, isAddToTail) {
      !isAddToTail && $scope.selectedAll(false) // 和webmail保持一致，刷新邮件列表后重置选择
      $scope.noMail = aMessages.length === 0

      aMessages.forEach(function (item) {
        const from = item.messageInfo.from
        item.messageInfo.name = $utils.$email.parseTrueName(from)
        item.messageInfo.summary = item.messageInfo.summary || $translate.instant('MAIL.NO_SUMMARY')
        item.messageInfo.isStranger = contactService.isStranger(from)
        item.id = item.messageInfo.id
        $scope.contactId = item.messageInfo.email = $utils.$email.parse(from).addr
      })

      if (isAddToTail) {
        $scope.messageWrappers = $scope.messageWrappers.concat(aMessages)
        $ionicScrollDelegate.resize()
      } else {
        handleFetchedMessages(aMessages)
      }
    }
    const fetchMessages = function (start, limit, isRefresh) {
      const who = isRefresh ? 'isRefreshLoading' : 'isLoading'
      $scope[who] = true
      $scope.badNetwork = false
      return $scope.folder.fetchMessages(start, limit).then(function (aMsgs) {
        // 下拉刷新的数据不缓存，仅对每次进入文件夹拉取的前20条数据缓存
        if ($rootScope.settings.enableMailCache && !isRefresh && IndexedDB.isReady()) {
          const cacheId = `mail_list_fid:${$scope.fid}:${$scope.filterType}_cache`
          const cache = aMsgs.map(msg => msg.messageInfo)
          IndexedDB.setItem(cacheId, cache)
        }
        updateMessageWrappers(aMsgs)
        $scope.noMoreMessage = $scope.messageWrappers.length >= $scope.folder.totals
      }, function (reason) {
        if (reason.code === 'FA_BAD_NETWORK') $scope.badNetwork = true
        if ($rootScope.settings.enableMailCache && !isRefresh && IndexedDB.isReady()) {
          const cacheId = `mail_list_fid:${$scope.fid}:${$scope.filterType}_cache`
          return IndexedDB.getItem(cacheId).then(cache => {
            if (cache && cache.length) {
              cache = Message.buildMessages(cache)
              updateMessageWrappers(cache)
            } else {
              return $q.reject(reason)
            }
          })
        } else {
          return $q.reject(reason)
        }
      }).finally(function () {
        const who = isRefresh ? 'isRefreshLoading' : 'isLoading'
        $scope[who] = false
        $scope.isApppushRefresh = false
      })
    }

    const loadMoreMessages = function () {
      $scope.loadingMoreMsg = true
      $scope.folder.loadMoreMessages($scope.messageWrappers.length).then(function (aMsgs) {
        updateMessageWrappers(aMsgs, true)
        $scope.noMoreMessage = $scope.messageWrappers.length >= $scope.folder.totals
      }).finally(function () {
        $scope.loadingMoreMsg = false
        // 解决因为页面的触底回弹效果还没结束而ajax请求过快完成,导致infiniteScroll组件再次触发loadMoreMessages方法，所以要主动延迟broadcast的时机
        setTimeout(function () {
          $scope.$broadcast('scroll.infiniteScrollComplete')
        })
      })
    }

    $scope.loadMoreMessages = function () {
      if ($scope.folder.auth2Locked) {
        // 文件夹需要二次解锁
        secondAuthService.alertFolderUnlock(function () {
          loadMoreMessages()
        })

        return
      }

      loadMoreMessages()
    }

    $scope.listMessages = function (start, limit, isRefresh) {
      $scope.messageWrappers = $scope.messageWrappers || []
      if (!$scope.folder) return $q.reject('FA_NO_FOLDER_SELECTED')

      // 文件夹是否需要二次解锁
      return $scope.folder.auth2Locked ? secondAuthService.alertFolderUnlock(function() {
        return fetchMessages(start, limit, isRefresh)
      }) : fetchMessages(start, limit, isRefresh)
    }

    $scope.toggleSelectMode = function () {
      const sharedAccess = User.getSelectedAccountAccess()
      if (sharedAccess === 0 || sharedAccess === 2) {
        $utils.$notify.set({ message: $translate.instant('SETTING.SHARED_MAILBOX.NO_PERMISSION_TO_OPERATE') })
        return
      }
      if (!$scope.isSelectMode) {
        LA.track('A1D1')
      } else {
        LA.track('A1D101')
      }
      $ionicListDelegate.closeOptionButtons()
      $scope.isSelectMode = !$scope.isSelectMode
      if ($scope.isSelectMode) {
        $scope.$broadcast('RESET_SELECT_ITEM')
      }
      $scope.msgHandlerDelegate.data = {}
      $scope.msgHandlerDelegate.readForbidden = !$scope.msgHandlerDelegate.readForbidden
      $scope.showSelectAll = true
    }

    $scope.showSelectAll = true // 显示全选还是全不选
    $scope.selectedAll = function (isSelectAll) {
      angular.forEach($scope.messageWrappers, (msgItem) => {
        msgItem.messageInfo.isChecked = !!isSelectAll
        $scope.msgHandlerDelegate.data = $scope.msgHandlerDelegate.data || {}
        if (msgItem.messageInfo.isChecked) {
          $scope.msgHandlerDelegate.data[msgItem.messageInfo.id] = msgItem
        } else {
          delete $scope.msgHandlerDelegate.data[msgItem.messageInfo.id]
        }
      })

      $scope.showSelectAll = !isSelectAll
    }

    function watchMsgChange() {
      $scope.$watch(function () {
        return $scope.folder.messages.total
      }, function (value) {
        if (angular.isNumber(value)) {
          $scope.mailTotal = value
          console.log($scope.mailTotal)
        }
      })
    }

    /* 切换菜单时重置列表页选择模式 */
    $scope.$on('SWITCH_MENU', function () {
      if ($scope.isSelectMode) {
        $scope.toggleSelectMode()
      }
    })
    /* 刷新文件夹状态 */
    // $rootScope.$on('FOLDERS.REFRESH', function () {
    //   initFoldersStatus(true)
    // })
    $rootScope.$on('LIST.REFRESH', function () {
      /** 刷新当前列表 */
      /** refresh when updating corresponding list */
      $scope.refreshCurrentFolder(false)
    })

    $rootScope.$on('MAILLIST.REFRESH', function () {
      /** 刷新当前列表 */
      /** refresh when updating corresponding list */
      $scope.messages = []
      getMailDealings(true)
    })

    $scope.markSelectedRead = function () {
      LA.track('A1D102')
      const aMessageToMark = getSelectedMailId()
      const mboxa = User.getSelectedAccountSymbol()
      if (aMessageToMark && aMessageToMark.length > 0) {
        aMessageToMark[0].mark('read', true, aMessageToMark, mboxa)
        this.toggleSelectMode()
      }
    }

    $scope.removeSelected = function () {
      LA.track('A1D104')
      const aMessageToRemove = getSelectedMailId()
      const mboxa = User.getSelectedAccountSymbol()
      if (aMessageToRemove && aMessageToRemove.length > 0) {
        this.msgHandlerDelegate.removeMessages(aMessageToRemove, mboxa)
      }
    }

    // 获取选择模式被选中邮件的id
    function getSelectedMailId() {
      const selectedIds = []
      const handleData = $scope.msgHandlerDelegate.data
      for (const mid in handleData) {
        selectedIds.push(handleData[mid])
      }
      if (selectedIds.length > 0) {
        return selectedIds
      } else {
        $utils.$notify.set({ message: $translate.instant('MAIL_OP_TIPS.NEED_SELECTED') })
        return false
      }
    }

    function openSelectFolderModal(action, params, mboxa) {
      $scope.topFolderWrappers = null
      $scope.otherFolderWrappers = null
      $ionicListDelegate.closeOptionButtons()
      if ($scope.isSelectMode) {
        $scope.toggleSelectMode()
      }

      $scope.folderModal = $phoneModal.fromTemplate(require('views/mail/folders-frame.html'), {
        scope: $scope,
        animation: 'scale-in'
      })
      $utils.$modalFunc.prepareModalBack($scope.folderModal, 'remove', $scope.closeSelectFolderModal)
      $scope.isSelectFolderModalLoading = true
      $scope.hideVirtualFolder = action === 'move'
      mailFolderService.refreshFolderStats(mboxa).then(function () {
      }).finally(function () {
        mailFolderService.listFolders(mboxa).then(function (folders) {
          if (action === 'move') {
            const fid = params[0].messageInfo.fid
            const topFolderWrappers = cloneDeep(folders.topFolders)
            const otherFolderWrappers = cloneDeep(folders.otherFolders)
            if (every(params, item => item.messageInfo.fid === fid)) {
              const disableFolder = function(folders) {
                if (!folders || !folders.length) return
                forEach(folders, folder => {
                  if (folder.data.id === fid) {
                    folder.data.disabled = true
                  } else {
                    disableFolder(folder.children)
                  }
                })
              }
              disableFolder(topFolderWrappers)
              disableFolder(otherFolderWrappers)
            }
            $scope.topFolderWrappers = topFolderWrappers
            $scope.otherFolderWrappers = otherFolderWrappers
          } else {
            wrapFolders(folders.topFolders)
            wrapFolders(folders.otherFolders)
            $scope.topFolderWrappers = folders.topFolders
            $scope.otherFolderWrappers = folders.otherFolders
          }
        }).finally(function () {
          $scope.isSelectFolderModalLoading = false
          $scope.folderModal.show()
        })
      })
    }
    // 打开过滤面板
    $scope.filterType = 'ALL'
    $scope.openFilterPanel = function ($event) {
      if (!$scope.showFilter) {
        $scope.showFilter = true
        $timeout(function () {
          document.querySelector('.filter-panel-content').classList.add('active')
          document.addEventListener('click', handleFilterPanelOtherClick, false)
        })
      } else {
        document.removeEventListener('click', handleFilterPanelOtherClick)
        const filterPanelContent = document.querySelector('.filter-panel-content')
        filterPanelContent && filterPanelContent.classList.add('leave')
        $timeout(function () {
          $scope.showFilter = false
        }, 400)
      }
      function handleFilterPanelOtherClick(event) {
        if (!event.target.classList.contains('filter-button')) {
          document.removeEventListener('click', handleFilterPanelOtherClick)
          const filterPanelContent = document.querySelector('.filter-panel-content')
          filterPanelContent && filterPanelContent.classList.add('leave')
          $timeout(function () {
            $scope.showFilter = false
          }, 400)
        }
      }
    }
    // 处理过滤
    $scope.handleMailListFilter = function (type) {
      $scope.filterType = type
      switch ($scope.filterType) {
        case 'ALL':
          $scope.folder.filterFlags = {
          }
          break
        case 'UNREAD':
          $scope.folder.filterFlags = {
            read: false
          }
          break
        case 'FLAG':
          $scope.folder.filterFlags = {
            flagged: true
          }
          break
        case 'URGENT':
          $scope.folder.filterFlags = {
            priority: 1
          }
          break
        case 'ATTACH':
          $scope.folder.filterFlags = {
            attached: true
          }
          break
      }
      $utils.$uiHelper.scrollToTop('mailListContent')
      // 开始过滤前重置状态
      $scope.messageWrappers = []
      $scope.noMoreMessage = false
      $scope.noMail = false
      $scope.listMessages()
    }
    // 过滤邮件
    // 打开文件夹列表面板
    $scope.showFoldersPanel = function ($event) {
      // todo 打开时更新
      if (!$scope.showFolders) {
        if ($rootScope.settings.settingMenu.sharedMailbox) {
          getMailboxUnreadMsgCount([$scope.selectedMailbox])
          getVisibleSharedMailbox()
        }
        document.addEventListener('click', handleFoldersPanelOtherClick, false)
        $scope.topFolderWrappers = null
        $scope.otherFolderWrappers = null
        $scope.hideVirtualFolder = false
        $ionicListDelegate.closeOptionButtons()
        if ($scope.isSelectMode) {
          $scope.toggleSelectMode()
        }
        mailFolderService.refreshFolderStats().then(function () {
        }).finally(function () {
          mailFolderService.listFolders().then(function (folders) {
            wrapFolders(folders.topFolders)
            wrapFolders(folders.otherFolders)
            $scope.topFolderWrappers = folders.topFolders
            $scope.otherFolderWrappers = folders.otherFolders
          }).finally(function () {
            $scope.showFolders = true
            $scope.folderHandlerDelegate = switchCurrentFolder
            $timeout(function () {
              document.querySelector('.folders-panel-content').classList.add('active')
            }, 200)
          })
        })
      } else {
        $scope.showMailboxAccounts = false
        document.removeEventListener('click', handleFoldersPanelOtherClick)
        const foldersPanelConent = document.querySelector('.folders-panel-content')
        foldersPanelConent && foldersPanelConent.classList.add('leave')
        $timeout(function () {
          $scope.showFolders = false
        }, 400)
      }

      function handleFoldersPanelOtherClick(event) {
        const excludeClass = ['accounts-entry', 'account-email', 'account-unread', 'accounts-list', 'folder-item-expand-icon', 'folder-name', 'folders-icon', 'icon-exchange', 'account-title', 'main-account', 'shared-account', 'account-info']
        if (!excludeClass.some(item => { return event.target.classList.contains(item) })) {
          document.removeEventListener('click', handleFoldersPanelOtherClick)
          const foldersPanelConent = document.querySelector('.folders-panel-content')
          foldersPanelConent && foldersPanelConent.classList.add('leave')
          $timeout(function () {
            $scope.showFolders = false
            $scope.showMailboxAccounts = false
          }, 400)
        }
      }
    }
    // 文件夹切换
    $scope.openSelectFolderModal = function () {
      // window.location.search = 'a=b'
      LA.track('A1B3')
      $scope.folderHandlerDelegate = switchCurrentFolder
      openSelectFolderModal()
    }

    $scope.closeSelectFolderModal = function () {
      $ionicListDelegate.closeOptionButtons()
      $scope.folderModal.remove()
    }

    $scope.$on('$destroy', function () {
      if ($scope.folderModal) {
        $scope.folderModal.remove()
      }
    })
    // 切換文件夾
    const switchCurrentFolder = {
      selectFolder: function (iFolderId) {
        // $scope.closeSelectFolderModal()
        $ionicHistory.nextViewOptions({
          historyRoot: true,
          disableAnimate: true
        })
        $scope.showFolders = false
        $state.go('frame.folder', { fid: iFolderId }, { reload: false })
      }
    }
    // 刷新当前文件夹
    $scope.refreshCurrentFolder = function () {
      $scope.listMessages(0, Math.ceil($scope.messageWrappers.length / $scope.per) * $scope.per, true).finally(function () {
        $scope.$emit('FOLDER.UNREADREFRESH')
        $scope.$broadcast('scroll.refreshComplete')
      })
    }
    // 注册刷新操作到JSBridge中供Native调用
    $scope.isApppushRefresh = false
    if (window.JSBridge) {
      window.JSBridge.registerHandler('refreshCurrentFolder', function (data, callback) {
        $scope.isApppushRefresh = true
        $scope.refreshCurrentFolder()
        callback && callback()
      })
    }
    // 格式化收件人
    $scope.formatRecevier = function (recevierStr) {
      const formatRecevierList = []
      const iRecevierStr = recevierStr.replace(/，/g, ',')
      const contactList = iRecevierStr.split(',')
      contactList.forEach(function (contact) {
        const hasName = contact.indexOf('"') !== -1
        let recevierName = ''
        let recevierEmail = ''
        if (hasName) {
          recevierName = $utils.$email.parseTrueName(contact)
          recevierEmail = $utils.$email.parse(contact).addr
        } else {
          recevierName = ''
          recevierEmail = contact
        }
        const temp = {
          name: recevierName,
          email: recevierEmail
        }
        formatRecevierList.push(temp)
      })
      return formatRecevierList
    }
    // 关闭移动模板
    $scope.closeHxphone = function () {
      globalHook.exec('handleCloseHxphone').catch(_ => window.close())
    }
    // 滚动事件处理函数
    $scope.enableScrollHideBar = $rootScope.settings.enableScrollHideBar
    let lastScrollTop = 0
    const delta = 80
    $scope.footerBar = document.getElementById('mailListFooterBar')
    $scope.scrollHandler = function () {
      const scrollTop = $ionicScrollDelegate.$getByHandle('mailListContent').getScrollPosition().top || 0
      const diff = Math.abs(lastScrollTop - scrollTop)
      if (diff < delta) {
        return
      }
      if (lastScrollTop > scrollTop) {
        $scope.footerBar.classList.remove('hide-bar')
        $scope.footerBar.classList.add('show-bar')
      } else {
        $scope.footerBar.classList.remove('show-bar')
        $scope.footerBar.classList.add('hide-bar')
      }
      lastScrollTop = scrollTop
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/mailFolderCtrl.js